(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holeeshop-testimonials"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const testimonialSections = document.querySelectorAll('.hs-testimonials');

  testimonialSections.forEach(function (section) {
    const track = section.querySelector('.hs-testimonials__track');
    const dotsEl = section.querySelector('.hs-dots');
    const prevBtn = section.querySelector('.hs-ctrl-btn[aria-label="Previous testimonial"]');
    const nextBtn = section.querySelector('.hs-ctrl-btn[aria-label="Next testimonial"]');

    if (!track) return;

    const cards = Array.from(track.querySelectorAll('.hs-card'));
    const total = cards.length;
    
    if (total === 0) return;

    let current = 0;
    let autoTimer = null;
    let isDragging = false;
    let startX = 0;
    let scrollStart = 0;
    let velocity = 0;
    let lastX = 0;
    let lastTime = 0;

    cards.forEach(function (_, i) {
      const dot = document.createElement('button');
      dot.className = 'hs-dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Go to testimonial ' + (i + 1));
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      
      dot.addEventListener('click', function () { 
        stopAuto(); 
        goTo(i); 
        startAuto(); 
      });
      
      if (dotsEl) dotsEl.appendChild(dot);
    });

    function getCardWidth() {
      const gap = parseInt(window.getComputedStyle(track).gap) || 16;
      return cards[0].offsetWidth + gap;
    }

    function goTo(idx) {
      current = ((idx % total) + total) % total;
      track.scrollTo({ left: current * getCardWidth(), behavior: 'smooth' });
      updateDots();
    }

    function updateDots() {
      if (!dotsEl) return;
      const dots = dotsEl.querySelectorAll('.hs-dot');
      dots.forEach(function (d, i) {
        const active = i === current;
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function startAuto() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      stopAuto();
      autoTimer = setInterval(function () { 
        goTo(current + 1); 
      }, 4000); 
    }

    function stopAuto() {
      if (autoTimer) { 
        clearInterval(autoTimer); 
        autoTimer = null; 
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { stopAuto(); goTo(current - 1); startAuto(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stopAuto(); goTo(current + 1); startAuto(); });

    section.addEventListener('mouseenter', stopAuto);
    section.addEventListener('mouseleave', startAuto);
    section.addEventListener('focusin', stopAuto);
    section.addEventListener('focusout', startAuto);

    track.addEventListener('mousedown', function (e) {
      isDragging = true; 
      startX = e.pageX; 
      scrollStart = track.scrollLeft;
      lastX = e.pageX; 
      lastTime = Date.now(); 
      velocity = 0;
      stopAuto(); 
      e.preventDefault();
    });
    
    window.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      const now = Date.now(); 
      const dt = now - lastTime;
      if (dt > 0) velocity = (e.pageX - lastX) / dt;
      lastX = e.pageX; 
      lastTime = now;
      track.scrollLeft = scrollStart - (e.pageX - startX);
    });
    
    window.addEventListener('mouseup', function () {
      if (!isDragging) return;
      isDragging = false;
      const snapped = Math.round(track.scrollLeft / getCardWidth());
      goTo(velocity < -0.3 ? snapped + 1 : velocity > 0.3 ? snapped - 1 : snapped);
      startAuto();
    });

    let touchStartX = 0;
    let touchStartScroll = 0;
    
    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartScroll = track.scrollLeft;
      stopAuto();
    }, { passive: true });
    
    track.addEventListener('touchmove', function (e) {
      track.scrollLeft = touchStartScroll + (touchStartX - e.touches[0].clientX);
    }, { passive: true });
    
    track.addEventListener('touchend', function (e) {
      const diff = touchStartX - e.changedTouches[0].clientX;
      goTo(Math.abs(diff) > 40 ? (diff > 0 ? current + 1 : current - 1) : current);
      startAuto();
    }, { passive: true });

    let scrollRaf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(scrollRaf);
      scrollRaf = requestAnimationFrame(function () {
        const idx = Math.round(track.scrollLeft / getCardWidth());
        if (idx !== current && idx >= 0 && idx < total) { 
          current = idx; 
          updateDots(); 
        }
      });
    }, { passive: true });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { stopAuto(); goTo(current - 1); startAuto(); }
      if (e.key === 'ArrowRight') { stopAuto(); goTo(current + 1); startAuto(); }
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { 
          e.isIntersecting ? startAuto() : stopAuto(); 
        });
      }, { threshold: 0.25 });
      observer.observe(section);
    } else {
      startAuto();
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
